import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const productNfceMappingStatusOptions = [
  { label: 'Habilitado', value: 'active' },
  { label: 'Desabilitado', value: 'disabled' },
]

export const productNfceMappingStatusStrategy = optionsToStrategy(productNfceMappingStatusOptions)
